import React from "react";
export const ClipPath = props => /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: props.clipId?.toString()
}, props.children));